module.exports = __webpack_public_path__ + "img/laboral.911cd59d.svg";